import { useParams } from "react-router-dom";
// import image
import securityLogo from "../../image/Logo_auto.svg";
import bannerImg from "../../image/mobility/modern-car-futuristic-road.jpg";
import driveImg from "../../image/mobility/cardoc2.jpg";
import carImg from "../../image/mobility/car3.jpg";
// import data
import contentData from "../../data/content/mobility/mobilityContent.json";
import AiToolsData from "../../data/aiTools.json";
import { DataStructure } from "../../types";
// import components
import { NavTree } from "../navigation/NavLinkPages";
import { MainFrame, Col2ContentFrame, SpacingFrame, Col3ContentFrame } from "../display/Frame";
import { BannerSection, BusinessBannerSection, BusinessUnitSection } from "../display/Sections";
import { ImageContain } from "../display/ImageFormat";
import { TextBody, TextBulletList, TitleSubtitle } from "../display/TextFormat";
import NoContent from "../content/NoContent";
// import functions
import { DisplayInfo2Cols, DisplayProductCards } from "../../functions/DisplayInfoFunctions";
// import context
import { useLang } from "../Context";

const typedContent : DataStructure = contentData;
const typedAiTools : DataStructure = AiToolsData;
const imagePath = "image/mobility/";


interface BannerProps {
    title: string;
    subtitle: string;
};
function DefaultBanner({ title, subtitle } : BannerProps) {
    return (
        <BannerSection image={bannerImg} title={ title } subtitle={ subtitle } />
    )
};

export default function Mobility() {
    const { lang } = useLang();
    const data = typedContent["Mobility"];
    const section1 = data[1];
    const section2 = data[2];
    const contentData = data["content"];

    return (
        <>
            <BusinessBannerSection 
                bgImage={ bannerImg }
                logoImage={ securityLogo }
                title={ data["title"][lang] }
                subtitle={ data["subtitle"][lang] }
            />

            <NavTree />

            <MainFrame>
                <SpacingFrame spacing={40}>
                    <TitleSubtitle title={ section1["title"][lang] } />
                    <Col3ContentFrame>
                        <DisplayProductCards data={ section1["solutions"] } />
                    </Col3ContentFrame>
                </SpacingFrame>
            </MainFrame>

            <BusinessUnitSection 
                title={ section2["title"][lang] } 
                text={ section2["text"][lang] } 
                data={ typedAiTools["aica"] }
            />

            <MainFrame>
                <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} />
            </MainFrame>
        </>
    )
};

export function MobilitySubpages() {
    const { lang } = useLang();
    const { mobilitySolutions } = useParams();

    const data = mobilitySolutions
        ? (typedContent[mobilitySolutions] as DataStructure | undefined)
        : undefined;
    const contentData = data?.["content"] as DataStructure | undefined;

    if (!data) {
        return <NoContent />;
    }

    return (
        <>
            <DefaultBanner title={data["title"][lang]} subtitle={data["subtitle"][lang]} />
            <NavTree />
            {contentData && (
                <DisplayInfo2Cols contentData={contentData} imagePath={imagePath} />
            )}
        </>
    );
}